import React, { useEffect, useState } from 'react';
import useGlobal from '../../store';
import {
  spaceById,
  getSpaceEquipment,
  getSpaceZones,
  getSpaceFeatures,
  getBuildingFloors,
  updateSpace,
  getSpaceNotes,
  addSpaceNote,
  getSiteZones,
  addZoneSpace
} from '../../services/MetadataService';
import { Auth } from "aws-amplify"

import LoadedEquipmentList from '../../loaded/LoadedEquipmentList';
import ZoneList from '../../components/ZoneList';
import FeatureList from '../../components/FeatureList';
import { getEntityDocuments } from "../../services/FileService";


import { ModeEdit, Settings } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useHistory } from 'react-router-dom';

import Notes from '../../components/Notes'
import { getBrickSpaceTypes, getPNNLSpaceTypes } from '../../services/DimensionsServices';
import { Autocomplete, IconButton, TextField  } from '@mui/material';
import FileList from "../../components/FileList";

import LoadedControls from '../../loaded/LoadedControls';

import PhotoCarousel from '../../components/PhotoCarousel';

//TODO: Move edit stuff to own component
const ShowSpace = (props) => {
	const [space, setSpace] = useState();
	const [zones, setZones] = useState();
	const [equipment, setEquipment] = useState();
	const [features, setFeatures] = useState();
	const [files, setFiles] = useState();
	const [photos, setPhotos] = useState();
	const [notes, setNotes] = useState();

	const[brickTypes, setBrickTypes] = useState([]);
	const[pnnlTypes, setPnnlTypes] = useState([]);
	const[floors, setFloors] = useState([]);
	const[allZones, setAllZones] = useState([]);

	const[editMode, setEditMode] = useState(false)
	const[, setError] = useState()
	const [isSubmitting, setIsSubmitting] = useState(false)

        let [currentState, currentActions] = useGlobal();

	let history = useHistory();

	let [currentUser, setCurrentUser] = useState()

	useEffect(() => {
		let spaceId = props && props.spaceId;
		if (!space) {
			spaceById(spaceId).then((response) => {
				setSpace(response);

				getBuildingFloors(response.building_id).then((response) => {
					setFloors(response);
				})

				getSiteZones(response.site_id).then((response) => {
					setAllZones(response);
				})
			});
		}

		getEquipment(spaceId);
		getZones(spaceId);
		getFeatures(spaceId);
		getFiles(spaceId);

		getSpaceNotes(spaceId).then(response => {
			setNotes(response)
		})

		getBrickSpaceTypes().then(response => {
			setBrickTypes(response)
		});

		getPNNLSpaceTypes().then(response => {
			setPnnlTypes(response)
		})

		if (!currentUser) {
            Auth.currentUserInfo().then(response => {
                setCurrentUser(response.attributes.name)
            })
        }
	}, [])


	const getFiles = (id) => {
        let spaceId = id || space.id
		let currentFiles = [];
		let currentPhotos = [];
		getEntityDocuments("locations/spaces", spaceId).then(files => {
			files.forEach(file => {

				if (file.type === 'Photo') {
					currentPhotos.push(file);
				}

				currentFiles.push(file)
			})

			setPhotos(currentPhotos)
			setFiles(currentFiles)
		})

	}

	const getEquipment = (spaceId) => {
		getSpaceEquipment(spaceId).then((response) => {
			setEquipment(response);
		});
	};

	const getZones = (spaceId) => {
		getSpaceZones(spaceId).then((response) => {
			setZones(response);
		});
	};

	const getFeatures = (spaceId) => {
		getSpaceFeatures(spaceId).then((response) => {
			setFeatures(response);
		});
	};

	const setName = (value) => {
			let currentSpace = Object.assign({}, space);
			currentSpace.name = value
			setSpace(currentSpace)
	}

	const setArea = (value) => {
		let currentSpace = Object.assign({}, space);
		currentSpace.area = value

		if (currentSpace.volume) currentSpace.volume = value * currentSpace.floor_to_ceiling_height
		setSpace(currentSpace)
	}

	const setHeight = (value) => {
		let currentSpace = Object.assign({}, space);
		currentSpace.floor_to_ceiling_height = value

		if (currentSpace.area) currentSpace.volume = value * currentSpace.area
		setSpace(currentSpace)
	}

	const submitChanges = () => {
		setIsSubmitting(true)
		updateSpace(space).then(response => {
			setIsSubmitting(false)
			setSpace(response)
			setEditMode(false)
		}).catch(error => {
			setIsSubmitting(false)
			console.log(error)
			setError("There was an error updating the space.")
		});
	}

	const addNote = async (note) => {
		note.author = currentUser;
		addSpaceNote(space.id, note).then(() => {
			getSpaceNotes(space.id).then(response => {
				setNotes(response)
			})
		}).catch(err => {
			console.log(err)
		})

	}

	const addToZone = async (zone) => {
		addZoneSpace(zone.id, space).then(() => {
			getZones(space.id);
			return true;
			
		})
	}

	useEffect(() => {
		if (space) {
		currentActions.setSpace(space);
		}
	}, [space]); //We should probably do the same with spaces and equipment but for now will call separately

	let defaultType = space && space.brick_space_type ? brickTypes.find(t => t.brick_space_type === space.brick_space_type) : null
	let defaultPnnlType = space && space.pnnl_space_type ? pnnlTypes.find(t => t.name === space.pnnl_space_type) : null
	let defaultFloor = floors && space ? floors.find(t => t.id == space.floor_id) : null

  	return (
    <div className="layer3">
		<LoadedControls siteId={space && space.site_id} equipmentList={equipment} />
      	<div className="location">
      		{  space ?
			<div className="space-stats">
			<div className="section-header">
				Stats
				<div className="edit-element">
					<IconButton
								variant="contained"
								color="primary"
								aria-label={"Edit these values" }

								onClick={() => {
									setEditMode(true)
							}}>
							<ModeEdit style={{fill: "#00b088", background: "white", transform: "scale(0.8)"}}/>
					</IconButton>
					<IconButton
								variant="contained"
								color="primary"
								aria-label={"View and edit space configuration" }

								onClick={() => {
									history.push("/variables/space/" + space.id)
							}}>
								<Settings style={{fill: "#003e51", background: "white", transform: "scale(0.8)"}}/>
					</IconButton>
				</div>
			</div>
			<div className="stats-container">
				{
					editMode ?
					<div className="stat-edit">
						<TextField label="Space Name" defaultValue={space.name} variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}}/>
					</div>
					:
					null
				}

				{
					editMode ?
					<div className="stat-edit">
						<TextField type="number" label="Area" defaultValue={space.area} variant="outlined" size="small" style={{ width: "100px" }} onChange={(e) => {setArea(e.target.value)}}/>
					</div>
					:
					<div className="stat">
						<div className="stat-label">Area</div>
						{ space.area ?
							<div className="stat-value">{space.area} sqft</div> :
							<div className="stat-unavailable">Add default Value</div>
						}
					</div>
				}

				{
					editMode ?
					<div className="stat-edit">
						<TextField type="number" label="Floor to Ceiling Height" defaultValue={space.floor_to_ceiling_height} variant="outlined" size="small" style={{ width: "150px" }} onChange={(e) => {setHeight(e.target.value)}}/>
					</div>
					:
					<div className="stat">
						<div className="stat-label">Floor to Ceiling Height</div>
						{space.floor_to_ceiling_height ?
							<div className="stat-value">{space.floor_to_ceiling_height} ft</div> :
							<div className="stat-unavailable">Add default Value</div> }
					</div>
				}

				{ editMode ?
					<div className="stat-edit">
						<Autocomplete
							disablePortal
							id="floor"
							options={floors}
							getOptionLabel={option => option.name}
							value={defaultFloor}
							renderInput={(params) => <TextField {...params} label="Floor" variant="outlined" fullWidth size="small" />}
							style={{ width: "150px" }}
							size="small"
							onChange={(event, newValue) => {
								let currentSpace = Object.assign({}, space);
								currentSpace.floor_id = newValue
								setSpace(currentSpace)
							}}
						/>
					</div>
					:
					<div className="stat">
						<div className="stat-label">Floor</div>
						{space ?
							<div className="stat-value">{space.floor_name}</div> :
							<div className="stat-unavailable">Add value</div> }
					</div>
				}

				{
					editMode ?
					<div className="stat-edit">
						<Autocomplete
							disablePortal
							id="Type"
							options={brickTypes}
							getOptionLabel={option => option.name}
							defaultValue={defaultType}
							renderInput={(params) => <TextField {...params} label="Type" variant="outlined" fullWidth size="small" />}
							style={{ width: "200px" }}
							size={"small"}
							groupBy={(option) => option.parent}
							onChange={(event, newValue) => {
								let currentSpace = Object.assign({}, space);
								currentSpace.brick_space_type = newValue.brick_space_type
								setSpace(currentSpace)
							}}
						/>
					</div>
					:

					<div className="stat">
						<div className="stat-label">Type</div>
						{defaultType ?
							<div className="stat-value">{defaultType.name}</div> :
							<div className="stat-unavailable">Add value</div> }
					</div>
				}

{
					editMode ?
					<div className="stat-edit">
						<Autocomplete
							disablePortal
							id="Type"
							options={pnnlTypes}
							defaultValue={defaultPnnlType}
							getOptionLabel={option => option.name}
							renderInput={(params) => <TextField {...params} label="PNNL Classification" variant="outlined" fullWidth size={"small"} />}
							style={{ width: "200px" }}
							size={"small"}
							onChange={(event, newValue) => {
								let currentSpace = Object.assign({}, space);
								currentSpace.pnnl_space_type = newValue.name
								setSpace(currentSpace)
							}}
						/>
					</div>
					:

					<div className="stat">
						<div className="stat-label">PNNL Classification</div>
						{defaultPnnlType ?
							<div className="stat-value">{defaultPnnlType.name}</div> :
							<div className="stat-unavailable">Add value</div> }
					</div>
				}

				{
					editMode ?
					<div className="stat">
						<LoadingButton
                            variant="contained"
                            loading={isSubmitting}
                            type="submit"
							onClick={submitChanges}
                            sx={{backgroundColor: "#003e51"}}>
                                Submit
                        </LoadingButton>
					</div>
					:
					null
				}
			</div>
		</div>
		: null }
        { space && <LoadedEquipmentList siteId={space.site_id} buildingId={space.building_id} spaceId={props.spaceId}/> }
        <ZoneList site_id={space && space.site_id} zones={zones} allZones={allZones} addToZoneCallback={addToZone} />
        { space && <FeatureList features={features} siteId={space.site_id} buildingId={space.building_id} spaceId={props.spaceId} /> }
		<Notes notes={notes} onSubmit={addNote} />
		<FileList files={files} context="space" id={props.spaceId} filesAccessor={getFiles} />
{/* 		<ScheduleView header="Occupancy Schedule" /> */}
			<div className="photo-container">
				<PhotoCarousel files={photos} />
			</div>
      	</div>
    </div>
  );
};

export default ShowSpace;
